import { Button } from '@/components/custom/erp';
import React from 'react';
import { DialogV2 } from '@/components/custom/erp';
import { AritoIcon } from '@/components/custom/erp';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteDialog = ({ open, onClose, onConfirm }: DeleteDialogProps) => {
  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xoá dữ liệu'
      maxWidth='sm'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      showFullscreenToggle={false}
      titleIcon={<AritoIcon icon={260} />}
      actions={
        <>
          <Button
            onClick={onConfirm}
            type='submit'
            className='bg-[rgba(15,118,110,0.9)] normal-case text-white hover:bg-[rgba(15,118,110,1)]'
          >
            <AritoIcon icon={884} className='mr-2' />
            Đồng ý
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} className='mr-2' />
            Huỷ
          </Button>
        </>
      }
    >
      <p className='min-w-[40vw] p-4 text-base font-medium'>Bạn có chắc chắn muốn xoá không?</p>
    </DialogV2>
  );
};

export default DeleteDialog;
